var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46748 0.860916H5.28913C2.67986 0.860916 1.04227 2.70695 1.04227 5.32039V12.3704C1.04227 14.9838 2.67221 16.8299 5.28913 16.8299H12.784C15.4043 16.8299 17.0309 14.9838 17.0309 12.3704V8.95479",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20475 7.75577L12.5504 1.42144C12.9302 1.04266 13.4452 0.829895 13.982 0.829895C14.5189 0.829895 15.0338 1.04266 15.4136 1.42144L16.449 2.45087C16.6371 2.63853 16.7863 2.86134 16.8881 3.10658C16.9899 3.35181 17.0423 3.61467 17.0423 3.88013C17.0423 4.14558 16.9899 4.40844 16.8881 4.65368C16.7863 4.89891 16.6371 5.12172 16.449 5.30938L10.0711 11.6776C9.72532 12.0229 9.25634 12.2169 8.76731 12.2169H5.58556L5.6654 9.01161C5.67706 8.53941 5.87017 8.08976 6.20475 7.75577V7.75577Z",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5872 2.3983L15.4655 6.27013",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.182255c88983edde6ca6ff3e591824a5.svg";
export { ForwardRef as ReactComponent };